import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringOptionalProperty, StringRequired } from '../primitive/string';

/**
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#initiate_the_checkout_process
 */
export const GtmAddPaymentInfoEventSchema = Schema.Struct({
  event: Schema.Literal('track.add_payment_info'),
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    coupon: StringOptionalProperty,
    payment_type: StringRequired,
    payment_code: StringRequired,
    payment_price: Number,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmAddPaymentInfoEventSchema' });

export type GtmAddPaymentInfoEvent = Schema.Schema.Type<typeof GtmAddPaymentInfoEventSchema>;
